import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where
} from 'firebase/firestore';
import { db } from '../firebase';

const COLL = 'articles';

function toArticle(doc) {
  const d = doc.data();
  const publishedAt = d.publishedAt && d.publishedAt.toDate ? d.publishedAt.toDate() : null;
  const updatedAt = d.updatedAt && d.updatedAt.toDate ? d.updatedAt.toDate() : null;
  return {
    id: doc.id,
    title: d.title,
    slug: d.slug,
    excerpt: d.excerpt,
    content: d.content,
    coverImage: d.coverImage,
    author: d.author,
    status: d.status,
    category: d.category,
    tags: d.tags || [],
    seoTitle: d.seoTitle || d.title,
    seoDescription: d.seoDescription || d.excerpt,
    publishedAt,
    updatedAt
  };
}

export async function listPublishedArticles({ max = 50 } = {}) {
  const q = query(
    collection(db, COLL),
    where('status', '==', 'published'),
    orderBy('publishedAt', 'desc'),
    limit(max)
  );
  const snap = await getDocs(q);
  return snap.docs.map(toArticle);
}

export async function getArticleBySlug(slug) {
  const q = query(
    collection(db, COLL),
    where('status', '==', 'published'),
    where('slug', '==', slug),
    limit(1)
  );
  const snap = await getDocs(q);
  return snap.empty ? null : toArticle(snap.docs[0]);
}
